import React from 'react';
import './Blogs.css';

const Blogs = () => {
    return (
        <div className="body bg-blog">
            <h2> Comming Soon ... </h2>
        </div>
    );
};

export default Blogs;